import React from 'react';
import {SvgIcon} from "@mui/material";

const ReportIcon = ({fgColor = "white", bgColor = "black", bgOpacity = 1, ...otherProps}) => {
    return (
        <SvgIcon {...otherProps}>
            <svg focusable={false} fill={bgColor}>
                <path
                    d="M9.1 5 5 9.1v5.8L9.1 19h5.8l4.1-4.1V9.1L14.9 5zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m1-3h-2V7h2z"
                    opacity={bgOpacity}
                />
            </svg>
            <svg focusable={false} fill={fgColor}>
                <path
                    d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"
                />
                <circle cx="12" cy="16" r="1"/>
                <path
                    d="M11 7h2v7h-2z"
                />
            </svg>
        </SvgIcon>
    );
};

export default ReportIcon;